<template>
    <div
        class="col-sm-12 px-4 mx-2"
        :class="grid ? 'col-md-' + grid : 'col-md-12'"
    >
        <div :class="`mb-2 ${inputGroup ? 'form-group' : ''}`">
            <div class="row align-items-center">
                <div class="input-group-prepend" v-if="inputGroup">
                    <button class="btn btn-light" @click.prevent="">
                        <i :class="iconBtn" v-if="iconBtn"></i>
                        <span v-else>{{ btnText }}</span>
                    </button>
                </div>
                <input
                    v-model="item"
                    v-on:input="
                        $emit('input', uppercase ? toUpper(item) : item),
                            $emit('change')
                    "
                    type="checkbox"
                    class="mr-2"
                    :class="
                        label == undefined
                            ? mt == undefined
                                ? 'mt-4'
                                : `mt-${mt}`
                            : ''
                    "
                    :min="min"
                    :max="max"
                    :readonly="readonly"
                    :disabled="disabled"
                    :placeholder="placeholder ? placeholder : label"
                    :required="required"
                    :style="uppercase ? 'text-transform: uppercase' : ''"
                />
                <label class="d-block font-weight-bold">{{ label }}</label>
            </div>
        </div>
    </div>
</template>
<script>
import { Money } from "v-money";
export default {
    components: { Money },
    props: [
        "type",
        "value",
        "label",
        "sublabel",
        "required",
        "grid",
        "readonly",
        "disabled",
        "placeholder",
        "mt",
        "inputGroup",
        "iconBtn",
        "btnText",
        "uppercase",
        "ajuda",
        "min",
        "max",
    ],
    data() {
        return {
            item: null,
            money: {
                decimal: ",",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 0,
                masked: false,
            },
        };
    },
    beforeMount() {
        // if (this.type == "money") {
        //     this.item = this.value + ",00";
        // } else {
        //     this.item = this.value;
        // }
        this.item = this.value;
    },
    watch: {
        value(n, o) {
            this.item = n;
        },
    },
    methods: {
        toUpper(item) {
            return item.toUpperCase();
        },
    },
};
</script>
